import { createApiAction } from '@app/packages/api/utils'
import type { ApiContact, ApiRegion } from '@app/packages/api/v2/types/entities'

export const getContacts = () =>
  createApiAction('getContacts', dispatch => dispatch<{ data: ApiContact[]; included?: ApiRegion[] }>({ method: 'GET', endpoint: '/api/v2/contacts' }))
